export enum SyncStatusEnum {
  NotSync = 0,
  Synced = 1,
  Syncing = 2,
  Error = 3
}
